module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "h-100 pa3"
  }, [_c('div', {
    staticClass: "tc pl-title mb3"
  }, [_vm._v("\n    " + _vm._s(_vm.stepperTitle) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "tl pl-caption",
    staticStyle: {
      "position": "relative",
      "margin": "auto"
    }
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, _vm._l((_vm.pageTitles), function(title, i) {
    return _c('pl-button', {
      key: title + i,
      staticClass: "ph3 instruction-title tc",
      class: {
        'selected-title': _vm.page === i
      },
      nativeOn: {
        "click": function($event) {
          _vm.page = i
        }
      }
    }, [_vm._v("\n        " + _vm._s(title) + "\n      ")])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "center-absolute-middle"
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    nativeOn: {
      "click": function($event) {
        return _vm.moveSlide('previous')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-grow instruction-box"
  }, [_vm._t("default", null, {
    "page": _vm.page
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "center-absolute-middle"
  }, [_c('pl-button', {
    staticClass: "pl-icon",
    nativeOn: {
      "click": function($event) {
        return _vm.moveSlide('next')
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-right"
  })])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center flex-grow ma3"
  }, _vm._l((_vm.pageTitles), function(title, i) {
    return _c('button', {
      staticClass: "dot",
      class: {
        selected: _vm.page === i
      },
      on: {
        "click": function($event) {
          _vm.page = i
        }
      }
    })
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('pl-button', {
    staticClass: "pl-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("\n      Got it!\n    ")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-34e9e1d8!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/onlineWalkthrough/onlineWalkthroughStepper.vue
// module id = 1332
// module chunks = 61